export default "__VITE_ASSET__DIwEUmdJ__"